// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2xCE-","subheader":"ReorderModal_subheader__3VepF","listWrap":"ReorderModal_listWrap__2ulNb"};